import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShoesDetailComponent } from './shoes-detail/shoes-detail.component';
import { AdminComponent }   from './admin/admin.component';
import { ShoesComponent } from './shoes/shoes.component';
import { WelcomeComponent } from './welcome/welcome.component';
import { MenComponent } from './men/men.component';
import { WomensComponent } from './womens/womens.component';
import { BoysComponent } from './boys/boys.component';
import { GirlsComponent } from './girls/girls.component';
import { ShopComponent } from './shop/shop.component';




const routes: Routes = [
  { path: '', component: WelcomeComponent},
  { path: 'shoes', component: ShoesComponent},
  { path: 'womens', component: WomensComponent},
  { path: 'men', component: MenComponent},
  { path: 'boys', component: BoysComponent},
  { path: 'girls', component: GirlsComponent},
  { path: 'shop', component: ShopComponent},
  { path: 'shoes/:id', component: ShoesDetailComponent},
  { path: 'admin', component: AdminComponent},
]

@NgModule({
  exports: [
    RouterModule
  ],
  imports: [
    RouterModule.forRoot(routes)
  ]
})
export class AppRoutingModule {

}



// WEBPACK FOOTER //
// /Users/juliusbade/Desktop/UnderArmour-Rebuild/src/app/app-routing.module.ts